/**
 *
 * Districts
 *
 */

import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import { Breadcrumb, Layout, Spin, Card, Result, Button } from "antd";
import LeadContext from "../../contexts/leads";
import Navbar from "../../components/navbar";
import "./styles.css";
import District from "../../components/maps/district";
import LeadCard from "../../components/leadCards";
import Leads from "../../components/leads";
import india from "../../utils/images/india.svg";
import "./styles.css";

const { Header, Content } = Layout;

export function Districts({ props }) {
  const [data, setData] = useState({ subdistrict: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [questions, setQuestions] = useState({ question: [] });
  const { supplyApi } = useContext(LeadContext);

  const heading = props.match.params.district
    .replace(/[^A-Za-z]+/g, " ")
    .toLowerCase()
    .slice(1)
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  const state = props.match.params.state
    .replace(/[^A-Za-z]+/g, " ")
    .toLowerCase()
    .slice(1)
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  useEffect(() => {
    loadQuestions();
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = () => {
    setLoading(true);
    supplyApi
      .get(`districts/${props.match.params.district}/`)
      .then(response => {
        setData({ subdistrict: response.data });
        setLoading(false);
      })
      .catch(err => {
        setError(true);
        setLoading(false);
      });
  };

  const loadQuestions = async () => {
    setLoading(true);
    supplyApi
      .get("seed/")
      .then(response => {
        setQuestions({ question: response.data.questions });
        setLoading(false);
      })
      .catch(err => {
        setError(true);
        setLoading(false);
      });
  };

  if (loading !== false) {
    return <Spin spinning={!loading} />;
  }

  if (error) {
    return (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <>
            <Button type="primary" onClick={() => (window.location.href = "/")}>
              Home
            </Button>
            <Button type="primary" onClick={() => (window.location.href = "/")}>
              Another Location
            </Button>
          </>
        }
      />
    );
  }

  if (data.subdistrict.name) {
    const title = (
      <Breadcrumb>
        <Breadcrumb.Item href="/">
          <span>
            <img src={india} alt="india" style={{ height: 35, width: 35 }} />
          </span>
        </Breadcrumb.Item>

        <Breadcrumb.Item
          href={`/${props.match.params.state}`}
          className="heading"
        >
          {state}
        </Breadcrumb.Item>
        <Breadcrumb.Item>{heading}</Breadcrumb.Item>
      </Breadcrumb>
    );

    return (
      <div>
        <Helmet>
          <title> Zo Supply | {heading} </title>
        </Helmet>
        <Header className="header">
          <Navbar />
        </Header>
        <Content className="content">
          <Card title={title}>
            <div>
              <Leads id={data.subdistrict.id} />
            </div>
            <div style={{ height: "50vh" }}>
              <District geometry={data.subdistrict.geometry} />
            </div>
          </Card>
          <LeadCard questions={questions} id={data.subdistrict.id} />
        </Content>
      </div>
    );
  }

  return null;
}

export default Districts;
